import { execute, FilterConditions, INSERT, SELECT, UPDATE } from "@/utils/database_module";
import { logDebug, logError } from '@/utils/helpers';
import { Conflict, ConflictHistory, ConflictStatus,  Devis,  Order, OrderHistory, OrderStatus, Product, SpecialOrderQuote, SpecialProductData, User, UserSession, Versement } from "@/utils/types";
import { get } from "http";
import moment from "moment";

type  OrderData = Omit<Order, "id" | "date" | "modified_date"  |"name" | "product" |  "user" | "history" | "invoices"> & {invoices? : string};

const orders = {
    getAll : async (filter : { selectedStatus? :any , startDate? : string , endDate? : string , limit? : number , order? : string , user_id? : number , is_order_special? : 0 | 1 | undefined , currentPage? : number}) => {
        let { selectedStatus , startDate , endDate , user_id, limit, currentPage, order, is_order_special, } = filter;
        if (!limit) limit = 1000000
        if (!currentPage) currentPage = 1
        
        const userQuery = `SELECT id, first_name, last_name, email, phone_numbers, profile_pic ,token,  adress FROM users WHERE role = 'user' ORDER BY id DESC`;
        const users = (await execute(userQuery)) as User[];
        for (const user of users) {
            user.phone_numbers = typeof   user.phone_numbers ?  JSON.parse(`${user?.phone_numbers}`)   :   user.phone_numbers
        }
  
        
        let conditions: FilterConditions = [{column: "is_deleted", operator: "=", value: 0,}];
        
        if (user_id)  conditions.push({column: "user_id", operator: "=", value: user_id,})
        if (is_order_special != undefined && !isNaN(is_order_special) ) conditions.push({column: "is_special", operator: "=", value: is_order_special,})
        if (selectedStatus && parseInt(selectedStatus) != 0) conditions.push({column: "status", operator: "=", value: parseInt(selectedStatus),})
        logDebug("orders getall", conditions)
        const orders = await SELECT("orders", { conditions: conditions, order: order ? order : "modified_date DESC", limit: !isNaN(parseInt(`${limit * currentPage}`)) ? parseInt(`${limit * currentPage}`) : limit, }) as Order[]

        const filteredOrders = orders.filter((order) => {
            const orderDate = moment(order.date).format("YYYY-MM-DD");
            if ( startDate && !moment(orderDate).isSameOrAfter( moment(startDate).format("YYYY-MM-DD") ) )
                return false;
            if ( endDate && !moment(orderDate).isSameOrBefore( moment(endDate).format("YYYY-MM-DD") ) )
                return false;
            return true;
        })
        if(filteredOrders.length == 0) return []

        const filteredOrdersIDs = filteredOrders.map((order) => order.id);
        let payements=  filteredOrdersIDs.length != 0? (await execute(`SELECT * FROM versement WHERE order_id IN (${filteredOrdersIDs.join(", ")}) `)) as Versement[] : [];
        
        const ordersStatuses = await SELECT('order_status' , {}) as OrderStatus[]

        const filteredOrdersProductIDs = filteredOrders.map((order) => order.product_id);
        let products = filteredOrdersProductIDs.length != 0? (await execute(`SELECT * FROM products WHERE id IN (${filteredOrdersProductIDs.join(", ")}) `)) as Product[] : [];
       
        for (const p of products) {
            p.name = typeof p.name == 'string' ? JSON.parse(`${p.name}`): p.name
        }

        for (const order of filteredOrders) {
            order.versements = payements.filter((payemnt) => payemnt.order_id == order.id);
            order.user  = users.find((user) => user.id == order.user_id);
            order.status = ordersStatuses.find((status) => status.id == order.status)!;
            order.product  = products.find((product) => product.id === order.product_id);
            if (order.product ) {
                order.product.images = typeof order.product.images == 'string' ? JSON.parse(order.product.images) : order.product.images;
                order.product.name = typeof order.product.name == 'string' ? JSON.parse(order.product.name) : order.product.name;
            }
        }

        return filteredOrders
    },



    getOne : async (id : number) => {
        const [order] = await SELECT("orders" , { conditions : [{column : "id" , operator : "=" , value : id }] }) as Order[];
        if (!order) throw new Error("Order not found");            
       
        order.invoices = JSON.parse(`${order?.invoices}`);
        order.versements  = await SELECT("versement" , { conditions : [{column : "order_id" , operator : "=" , value : id }] }) as Versement[];
        
        [order.user]  = await SELECT("users" , { conditions : [{column : "id" , operator : "=" , value : order.user_id }] as FilterConditions }) as User[];        
        const orderStatuses = await SELECT('order_status' , { }) as OrderStatus[];
        order.status  = orderStatuses.find((status) => status.id == order.status) as OrderStatus;
        [order.product]  = await SELECT("products" , { conditions : [{column : "id" , operator : "=" , value : order.product_id }] }) as Product[];
        if (order.product ) {
            order.product.images = typeof order.product.images == 'string' ? JSON.parse(order.product.images) : order.product.images;
            order.product.name = typeof order.product.name == 'string' ? JSON.parse(order.product.name) : order.product.name;
        }
        
        order.conflicts = await SELECT("conflicts" , { conditions : [{column : "order_id" , operator : "=" , value : id }] }) as Conflict[];
        const conflictsStatuses = await SELECT("conflicts" , { }) as ConflictStatus[];
        for (const conflict of order.conflicts) {
            conflict.status = conflictsStatuses.find((status) => status.id == conflict.status)!;
        }

        const history = await SELECT("orders_history" , { conditions : [{column : "order_id" , operator : "=" , value : id }] }) as OrderHistory[];
        if (history.length == 0) return order;
        
        const userIds = history.map((data) => data.user_id);
        const users = (await execute( `SELECT first_name , last_name , role ,profile_pic ,email,  id FROM users WHERE id IN (${userIds.join(",")})`)) as User[];
        
        for (const historyItem of history) {
          historyItem.user=  users.find((user) => user.id == historyItem.user_id);

          if(historyItem.details && typeof historyItem.details.new_status == "number")
              historyItem.details.new_status = orderStatuses.find((status) => status.id == historyItem.details.new_status) as OrderStatus;


          if(historyItem.details && typeof historyItem.details.old_status == "number")
              historyItem.details.old_status = orderStatuses.find((status) => status.id == historyItem.details.old_status) as OrderStatus;
        }
        
        order.history = history;
        return order        

    },


    update : async (id : number , data :{order : Partial<OrderData>, history : Partial<OrderHistory>} ) => {
        const { order , history } = data
        if(order.status == 7 || order.status == 13)
            order.shipping_date = moment().format("YYYY-MM-DD HH:mm:ss")
        await INSERT("orders_history" , { order_id : id , user_id : history.user_id , action : history.action , details : {...history.details , new_status : order.status} , color : history?.color ? history.color : "#ddsfs"})
        return await UPDATE("orders" , order , [{column : "id" , operator : "=" , value : id}])
        
    },
    
    insert : async (data : SpecialProductData  , session : UserSession) => {
        const orderToInsert = data.addedOrder;
        let insertedOrder: Order |null = null;
        if(orderToInsert.is_special == undefined) throw new Error("Unable to determine the type of the quote (`ìs_special` Must be defined)")
          
          if (orderToInsert?.is_special == 0) {
            const [product] = (await SELECT("products", { columns: ["id", "reference"], conditions: [ { column: "id", operator: "=", value: orderToInsert.product_id, }, ], })) as Product[];
          
          if(!product || !product.reference) throw new Error( "Product not found");
    
          const [devis] = await SELECT("devis", {
            columns: ["price"],
            conditions: [
              { column: "product_ref", operator: "=", value: product.reference, },
              { column: "min_quantity", operator: "<=", value: orderToInsert.quantity!, },
              { column: "max_quantity", operator: ">", value: orderToInsert.quantity!, },
              { column: "is_deleted", operator: "=", value: 0 },
            ],
          }) as Devis[];
    
          let newOrder = orderToInsert;
    
          if (devis) {
            const total_price = devis.price * orderToInsert.quantity!;
            newOrder = { ...orderToInsert, total_price: total_price, unit_price: devis.price, status: 2, } 
            }
    
          insertedOrder = (await INSERT("orders", newOrder)) as Order;
    
        }
    
        if (orderToInsert?.is_special == 1) {
          const {package_info, price: userProvidedPrice} = data;
          const {length, width, height, weight} = package_info;
          const total_quantity = orderToInsert.quantity;
          let devis = 0;
    
          if (!length || !width || !height || !weight || !total_quantity || !userProvidedPrice) throw  new Error("Missing package info");
          
          const specialOrderQuotes = (await SELECT("special_order_quote", {
            conditions: [{ column: "is_deleted", operator: "=", value: 0 }],
            order: "JSON_EXTRACT(standard_quote, '$.max_product_price') + 0 ASC ",
          })) as SpecialOrderQuote[];
          
          
          let calculatedWeight = length * width * height / (5000);
          logDebug("weight", calculatedWeight);
          logDebug("data?.weight", weight );
          
          // * 1- Si le poids calculé est supérieur à celui saisi par l'utilisateur, on poursuit le calcul avec le poids calculé. Sinon, on utilise le poids fourni par l'utilisateur.
          calculatedWeight = Math.max(calculatedWeight, weight);
          
          const unitWeight = (calculatedWeight * 1000) / total_quantity;
          logDebug("userProvidedPrice:", userProvidedPrice);
          logDebug("unitWeight:", unitWeight);
          logDebug("total_quantity:", total_quantity);
          
          
          const [currentUser] = await SELECT('users', {conditions: [{column: "id", operator: "=", value: session.id!}], columns:["id", "is_special"]}) as User[]
          const is_special = currentUser?.is_special;
          const quote = specialOrderQuotes.find( q => unitWeight >= q.min_weight && unitWeight < q.max_weight) as SpecialOrderQuote;
          logDebug("quote:", quote);
          
          if (is_special == 0) {
            // * 2.1 - Si le prix de produit de l'intervalle est supérieur au prix saisi par l'utilisateur, on utilise le devis de cet intervalle. 
            if ( quote?.standard_quote?.max_product_price >= userProvidedPrice! ) {
              devis = quote?.standard_quote?.quote;
              logDebug(`${quote?.min_weight} <= ${unitWeight} && ${unitWeight} < ${quote?.max_weight} && ${quote?.special_quote?.max_product_price} > ${userProvidedPrice!} `);
            } else{
              // * 2.2 Sinon, on sélectionne le devis du premier intervalle ayant un prix de produit supérieur à celui saisi par l'utilisateur.
              let foundQuote = specialOrderQuotes.find((quote) => quote?.standard_quote?.max_product_price >= userProvidedPrice!  );
              devis = foundQuote?.standard_quote?.quote ?? 0;
            }
          }
          if (is_special == 1) {
            const priceWithinRange = quote?.special_quote?.min_product_price <= userProvidedPrice && quote?.special_quote?.max_product_price > userProvidedPrice;
            if (priceWithinRange) {
              devis = quote?.special_quote?.quote;
            } else{
              let foundQuote =
              specialOrderQuotes.find(
                (quote, index) => index > 0 && userProvidedPrice! >= quote?.special_quote?.min_product_price && userProvidedPrice! < quote?.special_quote?.max_product_price);
              devis = foundQuote?.special_quote?.quote ?? 0;
            }
    
          }
    
          logDebug("devis :", devis);
    
          logDebug("total_price:", devis * total_quantity);
          insertedOrder = (await INSERT("orders", {
            ...orderToInsert,
            unit_price: devis,
            total_price: calculatedWeight>20 ? devis * total_quantity : devis * calculatedWeight ,
          })) as Order;
        }
    
         await INSERT("orders_history", {
          order_id: insertedOrder?.id,
          user_id: data.history.user_id,
          action: data.history.action,
          color: data.history.color,
          date: moment().format("YYYY-MM-DD HH:mm:ss"),
        });

        return insertedOrder;
    },

    
    delete : async (id : number) => {
      console.log("delete")
      return await UPDATE("orders" , { is_deleted : 1 } , [{column : "id" , operator : "=" , value : id}])
    },

    countTotal : async (filter : { selectedStatus? :any , startDate? : string , endDate? : string  , order? : string , user_id? : number , is_order_special? : 0 | 1 | undefined }) => {
      let { selectedStatus , startDate , endDate , user_id, is_order_special, } = filter;
      let conditions: FilterConditions = [{column: "is_deleted", operator: "=", value: 0,}];

      if (user_id)  conditions.push({column: "user_id", operator: "=", value: user_id,})
      if (is_order_special != undefined ) conditions.push({column: "is_special",operator: "=",value: is_order_special,})
      if (selectedStatus && parseInt(selectedStatus) != 0) conditions.push({column: "status",operator: "=",value: parseInt(selectedStatus),})
      

      const orders = await SELECT("orders", { conditions: conditions  }) as Order[]
      
      const filteredOrders = orders.filter((order) => {
        const orderDate = moment(order.date).format("YYYY-MM-DD");
        if ( startDate && !moment(orderDate).isSameOrAfter( moment(startDate).format("YYYY-MM-DD") ) )
            return false;
        if ( endDate && !moment(orderDate).isSameOrBefore( moment(endDate).format("YYYY-MM-DD") ) )
            return false;
        return true;
    })

      return filteredOrders.length
  },

    addHistory : async (history : Omit<OrderHistory, "id" | "date" >) => {
      return await INSERT("orders_history" , history)
    },

    
   
}


const apiError = (statusCode : number, message : string ) => {
    console.log(`---------------- [API Error ] ------------------`);
    logError(message);
    return Response.json({error : message, code : statusCode});
  }
  

  export default orders
  